import { useSelector } from 'react-redux'
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome'
import { faInfoCircle } from '@fortawesome/pro-duotone-svg-icons'
import { faRightToBracket, faSchoolCircleXmark } from '@fortawesome/pro-solid-svg-icons'

import { selectTranslate } from '../../../../reducers/LocaleReducer/LocalReducer'
import { ColorsPalette } from '../../../../config/colors'
import IconButton from '../../../../Components/antd/Buttons/IconButton'
import SchoolCard from '../../../../Components/shared/Schools/SchoolCard'
import { isNonEmptyArray } from '../../../../utils'

const SchoolAlreadyRegisteredScreen = ({ countries = [], schools = [], onLogin, onNotMySchool }) => {
  const t = useSelector(selectTranslate)

  return (
    <div className='pd-12'>
      <div className='modal-inner-container warning'>
        <div className='flex-row ai-bl'>
          <FontAwesomeIcon icon={faInfoCircle} color={ColorsPalette.WARNING_FONT} />
          <span className='pdl-4'><strong>{t('school_portal.duplicate.title')}</strong></span>
        </div>
        <br />
        <p>{t('school_portal.duplicate.explanation')}</p>
      </div>

      {isNonEmptyArray(schools) && (
        <div className='mt-12'>
          <div className='pdb-4'><b>{t('school_portal.duplicate.found')}</b></div>
          {schools.map(school => (
            <div key={`duplicate-${school.id}`} className='mb-4'>
              <SchoolCard countries={countries} school={school} />
            </div>
          ))}
        </div>
      )}

      <div className='mt-12 flex-column'>
        <IconButton
          className='logo-colored-button blue blue-ghost-hover w-100'
          icon={faRightToBracket}
          text={t('school_portal.duplicate.login')}
          type='primary'
          onClick={onLogin}
        />
        <div className='mt-8'>
          <IconButton
            className='logo-colored-button gray-ghost gray-hover w-100'
            icon={faSchoolCircleXmark}
            text={t('school_portal.duplicate.not_my_school')}
            type='neutral'
            onClick={onNotMySchool}
          />
        </div>
      </div>
    </div>
  )
}

export default SchoolAlreadyRegisteredScreen
